export default {
  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return '';
  },

  setCookie(name, value, expiration) {
    const expires = new Date();
    expires.setDate(expires.getDate() + expiration);
    document.cookie = `${name}=${value};expires=${expires};path=/;SameSite=None;Secure`;
  },

  deleteCookie(name) {
    const d = new Date();
    d.setTime(d.getTime() - (1000 * 60 * 60 * 24));
    const expires = `expires=${d.toGMTString()}`;
    document.cookie = `${name}=;${expires};path=/;SameSite=None;Secure`;
  },

  isCookieEnable() {
    this.setCookie('testEnable', 'isEnable', 3);
    const isEnable = this.getCookie('testEnable');
    return isEnable !== '';
  },
};
